import script from "./OilPressureDetailChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./OilPressureDetailChart.vue?vue&type=script&setup=true&lang=ts"

import "./OilPressureDetailChart.vue?vue&type=style&index=0&id=73c9753a&lang=css"

const __exports__ = script;

export default __exports__